import React from "react";
import classes from "./SmallModal.module.css";

const smallModal = props => (
  <div className={classes.SmallModal}>{props.children}</div>
);

export default smallModal;
